// Update shipping date
function updateShippingDatesFor(shipDateBottom) {
  // Create date object in EST timezone
  const estOptions = { timeZone: 'America/New_York' }
  const now = new Date()
  const estDate = new Date(now.toLocaleString('en-US', estOptions))

  const dayOfWeek = estDate.getDay() // 0 = Sunday, 1 = Monday, etc.
  const hour = estDate.getHours()

  let shippingDate = new Date(estDate)

  // Check if it's a weekday (Monday-Friday)
  if (dayOfWeek >= 1 && dayOfWeek <= 5) {
    // Before 12 PM EST on weekdays
    if (hour < 12) {
      shipDateBottom.innerHTML = 'today'
      return
    } else {
      // After 12 PM EST, ship tomorrow
      shippingDate.setDate(shippingDate.getDate() + 1)
      // If tomorrow is weekend, move to Monday
      if (shippingDate.getDay() === 0) {
        shippingDate.setDate(shippingDate.getDate() + 1)
      } else if (shippingDate.getDay() === 6) {
        shippingDate.setDate(shippingDate.getDate() + 2)
      }
    }
  } else {
    // It's weekend, ship next business day (Monday)
    shippingDate.setDate(shippingDate.getDate() + (dayOfWeek === 0 ? 1 : 2))
  }

  // Format the date
  const day = shippingDate.getDate()
  const suffix =
    day % 10 === 1 && day !== 11
      ? 'st'
      : day % 10 === 2 && day !== 12
      ? 'nd'
      : day % 10 === 3 && day !== 13
      ? 'rd'
      : 'th'
  const month = shippingDate.toLocaleString('en-us', { month: 'short' })
  const dayOfWeekName = shippingDate.toLocaleString('en-us', {
    weekday: 'short'
  })

  // Format with line break for two rows
  shipDateBottom.innerHTML =
    hour < 12 && dayOfWeek >= 1 && dayOfWeek <= 5
      ? 'today'
      : `${dayOfWeekName}, ${month} ${day}${suffix}`
}

// Update alternating number
function updateAlternatingNumbersFor(element) {
  let currentNumber = 19

  const intervalId = setInterval(() => {
    if (currentNumber > 1) {
      currentNumber--
      element.innerText = `${currentNumber}`
    } else {
      clearInterval(intervalId)
    }
  }, 4000)
}
